import {
  Culture,
  Football,
  Kino,
  Museum,
  Nature,
  Playground,
  Pool,
  Research,
  Workshop,
} from "../components/Icons/CustomIcons";

export const CATEGORIES = [
  { id: 1, name: "Sport & Bewegung", slug: "sport", icon: Football },
  { id: 2, name: "Kultur & Kunst", slug: "kultur", icon: Culture },
  { id: 3, name: "Natur & Tiere", slug: "natur", icon: Nature },
  {
    id: 7,
    name: "Forschung & Experiment",
    slug: "forschung-und-experiment",
    icon: Research,
  },
  { id: 4, name: "Museen & Ausstellungen", slug: "museen", icon: Museum },
  { id: 5, name: "Spielplätze", slug: "spielplaetze", icon: Playground },
  { id: 6, name: "Schwimmbäder", slug: "schwimmbaeder", icon: Pool },
  { id: 9, name: "Kino", slug: "kino", icon: Kino },
  { id: 8, name: "Workshops", slug: "workshops", icon: Workshop },
];

// Rollstuhl-Angaben (wheelchair_accessible) sind derzeit nicht zuverlaessig gepflegt.
// Solange das so ist, blendet das Nutzer-Frontend alle zugehoerigen Elemente aus:
// Badge auf der Karte, Hinweis auf Detail- und Kontrollseite, Filter und Eingabefeld.
// Wieder einblenden mit REACT_APP_SHOW_WHEELCHAIR=true in der .env (Neubau noetig).
// Die Daten selbst bleiben unberuehrt; im Admin-Frontend ist das Feld weiterhin da.
export const SHOW_WHEELCHAIR = process.env.REACT_APP_SHOW_WHEELCHAIR === 'true';
